<template>
  <div class="w-full text-sm">
    <div
      class="border border-gray-300 bg-gray-200 dark:border-dark-400 dark:bg-dark-500"
      style="padding: 2px 12px 2px 12px; border-radius: 1rem 1rem 0 0"
    >
      <label class="text-gray-800 dark:text-dark-text">
        {{ label }}
      </label>
    </div>
    <div class="w-full">
      <InputArea
        class="shadow-md border border-gray-300 text-gray-800 dark:border-dark-400 dark:text-dark-text dark:bg-dark-400"
        :isEditable="false"
        :onChange="onChange"
        style="height: 100px; border-radius: 0 0 1rem 1rem"
        :value="text"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import InputArea from './InputArea.vue'

import { useFreeSpaceJudgeDetailPresenter } from '@/presentation/composables/freeSpace/useFreeSpaceJudgeDetailPresenter'
import { useFreeSpaceStatePresenter } from '@/presentation/composables/freeSpace/useFreeSpaceStatePresenter'

export default defineComponent({
  components: {
    InputArea
  },
  props: {
    label: {
      type: String,
      required: true
    },
    onChange: {
      type: Function
    }
  },

  setup(props, ctx) {
    const freeSpaceState = useFreeSpaceStatePresenter()
    const freeSpaceJudgeDetailState = useFreeSpaceJudgeDetailPresenter()
    const text = computed(() =>
      freeSpaceJudgeDetailState.judgeDetail.value ? freeSpaceJudgeDetailState.judgeDetail.value?.userOutput : ''
    )

    return { text }
  }
})
</script>

<style lang="postcss"></style>
